module.exports = __webpack_public_path__ + "img/vf3.65089c66.png";